const Popup = ({ children, use }) => {
    return <div ref={use} className="popup">
        <div className="content">{children}</div>
    </div>
}
export default Popup